"use client";

import { useEffect } from "react";
import { fireAppointmentScheduled, postServerConversion } from "@/lib/tracking/chatgptAds";
import { readStoredAttributionData } from "@/lib/hooks/useUTM";

const DEDUPE_KEY_PREFIX = "chatgpt-ads-appt|";

/**
 * Calendly's own SDK posts `calendly.event_scheduled` to the parent window
 * when a visitor completes a booking — see `components/scripts/MixpanelScript.tsx`
 * for the same message shape used for Mixpanel tracking.
 */
export default function ChatGptAdsCalendlyListener() {
  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.data?.event !== "calendly.event_scheduled") return;
      const eventUri = e.data?.payload?.event?.uri;
      const inviteeUri = e.data?.payload?.invitee?.uri;
      if (!eventUri || !inviteeUri) return;

      const dedupeKey = `${DEDUPE_KEY_PREFIX}${eventUri}|${inviteeUri}`;
      try {
        if (window.sessionStorage.getItem(dedupeKey)) return;
        window.sessionStorage.setItem(dedupeKey, "1");
      } catch {
        // Privacy mode — best effort, allow the event through.
      }

      const eventId = fireAppointmentScheduled();
      postServerConversion({
        id: eventId,
        type: "appointment_scheduled",
        oppref: readStoredAttributionData().oppref,
        sourceUrl: window.location.href,
      });
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return null;
}
